/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { AuthDebugService } from './app/core/services/auth-debug.service';
import { TokenManagerService } from './app/core/services/token-manager.service';
import { SessionActivityService } from './app/core/services/session-activity.service';
import { ApplicationRef } from '@angular/core';
import { environment } from './environments/environment';

bootstrapApplication(AppComponent, appConfig)
  .then((appRef: ApplicationRef) => {
    // Initialize TokenManagerService to start auto-refresh
    const tokenManager = appRef.injector.get(TokenManagerService);
    console.log('✅ Token Manager initialized and ready');

    // Initialize SessionActivityService  to start activity tracking
    const sessionActivity = appRef.injector.get(SessionActivityService);
    console.log(
      '✅ Session Activity Service initialized and tracking user activity'
    );

    // Make AuthDebugService available globally for debugging
    if (!environment.production) {
      const authDebugService = appRef.injector.get(AuthDebugService);
      (window as any).debugAuth = authDebugService;
      console.log('🔧 Enhanced Debug utilities available:');
      console.log(
        '  - window.debugAuth.debugAuthState() - Debug current auth state'
      );
      console.log(
        '  - window.debugAuth.debugTokenManager() - Debug token manager status'
      );
      console.log(
        '  - window.debugAuth.debugSessionActivity() - Debug session activity'
      );
      console.log(
        '  - window.debugAuth.testTokenRefresh() - Test token refresh'
      );
      console.log(
        '  - window.debugAuth.testAutoRefresh() - Test automatic refresh'
      );
      console.log(
        '  - window.debugAuth.testSessionExtension() - Test session extension'
      );
      console.log('  - window.debugAuth.extendSession() - Extend user session');
      console.log(
        '  - window.debugAuth.resetTokenManager() - Reset token manager'
      );
      console.log('  - window.debugAuth.clearAuthData() - Clear all auth data');
      console.log('');
      console.log('🚀 Enhanced Authentication System Active!');
      console.log('   ✓ Auto-refresh: Tokens refreshed every 45 minutes');
      console.log(
        '   ✓ Activity tracking: Sessions extended when user is active'
      );
      console.log('   ✓ Smart detection: Warns before session expiry');
      console.log('   ✓ Extended sessions: Can stay active for 1+ hours');
      console.log('   ✓ Seamless experience: No unexpected logouts');
    }
  })
  .catch((err) => console.error(err));
